import { COOKIE_SAVINGS_ACCOUNT_TYPE } from '@/constants/cookies';
import { SAVINGS_TYPES } from '@/constants/savings';
import lang from '@/lang/middleware/products/banking/savings-accounts';

export default async ({ $api, app, $cookies, redirect, store }) => {
  const savingstype = $cookies.get(COOKIE_SAVINGS_ACCOUNT_TYPE);
  if (!savingstype || !SAVINGS_TYPES.includes(savingstype)) {
    return redirect(302, app.localePath('/compare-savings-accounts/'));
  }
  store.$i18n.mergeLocaleMessage('en', lang.en);
  const title = store.$i18n.t('search.title');
  store.commit('pageContent/setHead', { title });
  await $api('banking/savingsearches').then(r => store.commit('products/setValidations', r));
  store.commit('search/reset', { search: { savingstype }, type: 'saving' });
};
